import { Box, Button, IconButton, Typography, useTheme, } from "@mui/material";
import { useContext, useEffect, useMemo, useState , useCallback, useRef } from "react";
import { tokens, ColorModeContext } from "../../../theme";
import { mockTransactions } from  "../../../data/mockData";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import EmailIcon from "@mui/icons-material/Email";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TrafficIcon from "@mui/icons-material/Traffic";
import Header from  "../../../components/Header"  //../components/Header";
import RetainerChart from "../../../scenes/clientMonitoring/charts/retainerchart";
import GeographyChart from "../../../components/GeographyChart";
import BarChart from "../../../components/BarChart";
import StatBox from "../../../components/StatBox";
import ProgressCircle from "../../../components/ProgressCircle";
import SafeDatePicker from "../components/safeDatePicker";
import ConnString from "../../../ConnString.js";
import ToDoCount from "../components/ToDoCount";
import RetainerList from "../components/RetainerList";
import { green } from "@mui/material/colors";

const Connstring2 = ConnString.connstring;

const STATUS_FILTERS = {
  ALL: "ALL",
  BILLED: "Billed",
  COLLECTED: "Collected",
  FORBILLING: "For Billing",
};


const Retainersx = () => {
  // const theme = useTheme();
  // const colors = tokens(theme.palette.mode);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  useContext(ColorModeContext);

  
  
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

// Last day of current month
const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

const [selectedDateFrom, setSelectedDateFrom] = useState(firstDayOfMonth);
const [selectedDateTo, setSelectedDateTo] = useState(lastDayOfMonth);


    const [isFullscreen, setIsFullscreen] = useState(false);
    const matrixRef = useRef(null);
  
    const [companies, setCompanies] = useState([]);
  // const [selectedDateFrom, setSelectedDateFrom] = useState(new Date());
  // const [selectedDateTo, setSelectedDateTo] = useState(new Date());

  const [statusFilter, setStatusFilter] = useState(STATUS_FILTERS.ALL);
  const [returnFilter, setReturnFilter] = useState("ALL"); // Returnx filter
  const [searchCompany, setSearchCompany] = useState("");  // CompanyName search
  
  const compID = sessionStorage.getItem("compID");
  
    const formattedDateFrom = selectedDateFrom.toISOString().split("T")[0];
    const formattedDateTo = selectedDateTo.toISOString().split("T")[0];
  
    const fetchCompanies = useCallback(async () => {
      try {
        const response = await fetch(`${Connstring2}/api/DashboardRetainers`, {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            companyID: compID,
            datefrom: formattedDateFrom,
            dateto: formattedDateTo,
          }),
        });
  
        const data = await response.json();
        if (Array.isArray(data)) setCompanies(data);
        else console.error("Data format is incorrect. Expected an array.", data);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    }, [compID, formattedDateFrom, formattedDateTo]);
  

    useEffect(() => {
      fetchCompanies();
    }, [fetchCompanies]);

    
    const enterFullscreen = () => {
      if (!matrixRef.current) return;
    
      if (matrixRef.current.requestFullscreen) {
        matrixRef.current.requestFullscreen();
      } else if (matrixRef.current.webkitRequestFullscreen) {
        matrixRef.current.webkitRequestFullscreen();
      }
    };
    
    const exitFullscreen = () => {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    };
    
    
    //   useEffect(() => {
    //   const onChange = () => {
    //     setIsFullscreen(Boolean(document.fullscreenElement));
    //   };
    
    //   document.addEventListener("fullscreenchange", onChange);
    //   document.addEventListener("webkitfullscreenchange", onChange);
    
    //   return () => {
    //     document.removeEventListener("fullscreenchange", onChange);
    //     document.removeEventListener("webkitfullscreenchange", onChange);
    //   };
    // }, []);
    useEffect(() => {
      const onChange = () => {
        const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
        setIsFullscreen(Boolean(fsEl));
      };

      document.addEventListener("fullscreenchange", onChange);
      document.addEventListener("webkitfullscreenchange", onChange);

      return () => {
        document.removeEventListener("fullscreenchange", onChange);
        document.removeEventListener("webkitfullscreenchange", onChange);
      };
    }, []);
  
    // ✅ Build Return dropdown options dynamically
    const returnOptions = useMemo(() => {
      const set = new Set();
      companies.forEach((c) => {
        if (c?.Returnx) set.add(c.Returnx);
      });
      return ["ALL", ...Array.from(set).sort()];
    }, [companies]);
  

  const filteredCompanies = useMemo(() => {
      const q = searchCompany.trim().toLowerCase();
  
      return companies.filter((c) => {
        const statusOk =
          statusFilter === STATUS_FILTERS.ALL ? true : c.Statusx === statusFilter;
  
        const returnOk = returnFilter === "ALL" ? true : c.Returnx === returnFilter;
  
        const name = (c.CompanyName || "").toLowerCase();
        const searchOk = q ? name.includes(q) : true;
  
        return statusOk && returnOk && searchOk;
      });
    }, [companies, statusFilter, returnFilter, searchCompany]);
  
    // ✅ Counts should match the filtered dataset for the date range,
    // but NOT depend on the statusFilter (otherwise Done/ToDo boxes shrink when you click them).
    // So compute counts from "companies filtered by return + search only" (optional best UX).
    const companiesForCounts = useMemo(() => {
      const q = searchCompany.trim().toLowerCase();
      return companies.filter((c) => {
        const returnOk = returnFilter === "ALL" ? true : c.Returnx === returnFilter;
        const name = (c.CompanyName || "").toLowerCase();
        const searchOk = q ? name.includes(q) : true;
        return returnOk && searchOk;
      });
    }, [companies, returnFilter, searchCompany]);
  
    const taskDone = useMemo(
      () => companiesForCounts.filter((c) => c.Statusx === "Collected").length,
      [companiesForCounts]
    );
    const taskToDo = useMemo(
      () => companiesForCounts.filter((c) => c.Statusx === "For Billing").length,
      [companiesForCounts]
    );
    
    const taskBilled = useMemo(
      () => companiesForCounts.filter((c) => c.Statusx === "Billed").length,
      [companiesForCounts]
    );
    const totalTasks = useMemo(() => companiesForCounts.length, [companiesForCounts]);
    
  const clearFilters = () => {
    setStatusFilter(STATUS_FILTERS.ALL);
    setReturnFilter("ALL");
    setSearchCompany("");
  };

 
  const fullscreenStyles = isFullscreen
  ? { height: "100vh", maxHeight: "100vh", padding: 20 } 
  : {};

  return (
//<div ref={matrixRef} style={{ ...styles.tableContainer, ...fullscreenStyles }}>
   // <Box  m="20px">
   <Box
      ref={matrixRef}
      sx={{
        ...(isFullscreen
          ? {
              position: "relative",
              width: "100%",
              height: "100%",
              backgroundColor: colors.primary[400],
              p: 2,
              overflow: "auto",
            }
          : {}),
      }}
    >
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center"  style={styles.tableContainer} backgroundColor={colors.primary[400]}>
        <Header title="Client Retainers" subtitle="Welcome to your client retainers" />

      <Box>
        

        <IconButton
          onClick={() => (isFullscreen ? exitFullscreen() : enterFullscreen())}
          sx={{
            backgroundColor: colors.grey[700],
            color: colors.grey[100],
            borderRadius: 1,
            px: 1.5,
            py: 1,
            "&:hover": { backgroundColor: colors.grey[600] },
          }}
        >
        <FullscreenIcon />
          <Typography sx={{ ml: 1, fontSize: 12 }}>
            {isFullscreen ? "Exit Full Screen" : "Full Screen"}
          </Typography>
        </IconButton>

        </Box>
      </Box>
          <Box
          ref={matrixRef}
          sx={{
            backgroundColor: colors.primary[400],
            ...(isFullscreen
              ? { width: "100%", height: "100%", p: 2, overflow: "auto" }
              : {}),
          }}
>
        <form style={styles.form} backgroundColor={colors.primary[400]}>
            <div style={styles.formGroup}   >
            <SafeDatePicker
              label="Date From"
              value={selectedDateFrom}
              onChange={(d) => {
                setSelectedDateFrom(d);
                if (selectedDateTo && selectedDateTo < d) setSelectedDateTo(d);
              }}
            />
          </div>

          <div style={styles.formGroup}  >
            <SafeDatePicker
              label="Date To"
              value={selectedDateTo}
              minDate={selectedDateFrom}
              onChange={setSelectedDateTo}
            />
          </div>

           {/* ✅ Company search */}
        <div style={styles.formGroup}  backgroundColor={colors.primary[400]} >
          <label style={styles.label} backgroundColor={colors.primary[400]}>Company</label>
          <input
            value={searchCompany}
            onChange={(e) => setSearchCompany(e.target.value)}
            placeholder="Search company..."
            style={styles.search}
          />
      </div>
        {/* ✅ Clear filter button */}
        <button type="button" onClick={clearFilters} style={styles.clearBtn} backgroundColor={colors.primary[400]}>
          Clear filters
        </button>
        
        </form>

      <div style={styles.countContainer}  backgroundColor={colors.primary[400]}>

         <div style={styles.countRow}  backgroundColor={colors.primary[400]}>

           <div style={styles.countContainer}  backgroundColor={colors.primary[400]}>
               <ToDoCount
                count={taskDone}
                label="Collected"
                backgroundColor="#28a745"
                active={statusFilter === STATUS_FILTERS.COLLECTED}
                onClick={() => setStatusFilter(STATUS_FILTERS.COLLECTED)}
                />
                  <ToDoCount
                  count={taskToDo}
                  label="For Billing"
                  backgroundColor="#FF9EAA"
                  active={statusFilter === STATUS_FILTERS.FORBILLING}
                  onClick={() => setStatusFilter(STATUS_FILTERS.FORBILLING)}
                />
                 <ToDoCount
                count={taskBilled}
                label="Billed"
                active={statusFilter === STATUS_FILTERS.BILLED}
                    onClick={() => setStatusFilter(STATUS_FILTERS.BILLED)}
                  />

                   <ToDoCount
                  count={totalTasks}
                  label="Total"
                  active={statusFilter === STATUS_FILTERS.ALL}
                      onClick={() => setStatusFilter(STATUS_FILTERS.ALL)}
                    />

            </div>
              
            </div>

       

      </div>
      
        <RetainerList
            companies={filteredCompanies}
            dateFrom={formattedDateFrom}
            dateTo={formattedDateTo}
            refreshCompanies={fetchCompanies}
          />

      
      </Box>
      {/* GRID & CHARTS */}
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        gridAutoRows="140px"
        gap="20px"
      >
        {/* ROW 1 */}
        <Box
          gridColumn="span 3"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title="12,361"
            subtitle="Emails Sent"
            progress="0.75"
            increase="+14%"
            icon={
              <EmailIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 3"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title="431,225"
            subtitle="Sales Obtained"
            progress="0.50"
            increase="+21%"
            icon={
              <PointOfSaleIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 3"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title="32,441"
            subtitle="New Clients"
            progress="0.30"
            increase="+5%"
            icon={
              <PersonAddIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>
        <Box
          gridColumn="span 3"
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <StatBox
            title="1,325,134"
            subtitle="Traffic Received"
            progress="0.80"
            increase="+43%"
            icon={
              <TrafficIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
          />
        </Box>

        {/* ROW 2 */}
        <Box
          gridColumn="span 8"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
        >
          <Box
            mt="25px"
            p="0 30px"
            display="flex "
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography
                variant="h5"
                fontWeight="600"
                color={colors.grey[100]}
              >
                Revenue Generated
              </Typography>
              <Typography
                variant="h3"
                fontWeight="bold"
                color={colors.greenAccent[500]}
              >
                {/* $59,342.32 */}
              </Typography>
            </Box>
            <Box>
              <IconButton>
                <DownloadOutlinedIcon
                  sx={{ fontSize: "26px", color: colors.greenAccent[500] }}
                />
              </IconButton>
            </Box>
          </Box>
          <Box height="250px" m="-20px 0 0 0">
              
            <RetainerChart isDashboard={true}
              dateFrom={formattedDateFrom}
               dateTo={formattedDateTo}
             />
          </Box>
        </Box>
        <Box
          gridColumn="span 4"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
          overflow="auto"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            borderBottom={`4px solid ${colors.primary[500]}`}
            colors={colors.grey[100]}
            p="15px"
          >
            <Typography color={colors.grey[100]} variant="h5" fontWeight="600">
              Recent Transactions
            </Typography>
          </Box>
          {mockTransactions.map((transaction, i) => (
            <Box
              key={`${transaction.txId}-${i}`}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              borderBottom={`4px solid ${colors.primary[500]}`}
              p="15px"
            >
              <Box>
                <Typography
                  color={colors.greenAccent[500]}
                  variant="h5"
                  fontWeight="600"
                >
                  {transaction.txId}
                </Typography>
                <Typography color={colors.grey[100]}>
                  {transaction.user}
                </Typography>
              </Box>
              <Box color={colors.grey[100]}>{transaction.date}</Box>
              <Box
                backgroundColor={colors.greenAccent[500]}
                p="5px 10px"
                borderRadius="4px"
              >
                ${transaction.cost}
              </Box>
            </Box>
          ))}
        </Box>

        {/* ROW 3 */}
        <Box
          gridColumn="span 4"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
          p="30px"
        >
          <Typography variant="h5" fontWeight="600">
            Campaign
          </Typography>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mt="25px"
          >
            <ProgressCircle size="125" />
            <Typography
              variant="h5"
              color={colors.greenAccent[500]}
              sx={{ mt: "15px" }}
            >
              $48,352 revenue generated
            </Typography>
            <Typography>Includes extra misc expenditures and costs</Typography>
          </Box>
        </Box>
        <Box
          gridColumn="span 4"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
        >
          <Typography
            variant="h5"
            fontWeight="600"
            sx={{ padding: "30px 30px 0 30px" }}
          >
            Sales Quantity
          </Typography>
          <Box height="250px" mt="-20px">
            <BarChart isDashboard={true} />
          </Box>
        </Box>
        <Box
          gridColumn="span 4"
          gridRow="span 2"
          backgroundColor={colors.primary[400]}
          padding="30px"
        >
          <Typography
            variant="h5"
            fontWeight="600"
            sx={{ marginBottom: "15px" }}
          >
            Geography Based Traffic
          </Typography>
          <Box height="200px">
            <GeographyChart isDashboard={true} />
          </Box>
        </Box>
      </Box>
    </Box>
    //</div>1111
  );
};

const styles = {
  form: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "flex-start",
    gap: "16px",
    marginBottom: "10px",
    flexWrap: "wrap",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "6px",
  },
  label: { fontSize: 12, opacity: 0.8 },

  select: {
    height: 36,
    padding: "0 10px",
    borderRadius: 6,
    border: "1px solid #ccc",
    minWidth: 180,
  },
  search: {
    height: 36,
    padding: "0 10px",
    borderRadius: 6,
    border: "1px solid #ccc",
    minWidth: 220,
  },

  countRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    flexWrap: "wrap",
  },
  countContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    
  },
  clearBtn: {
    height: 36,
    padding: "0 14px",
    borderRadius: 8,
    border: "1px solid #ccc",
   // background: "#fff",
    cursor: "pointer",
  },
  dashboardGraphs: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    flexWrap: "wrap",
    gap: "16px",
  },
    tableContainer: {
    maxHeight: '1000px',
    overflow: 'auto',
    //  background: "#fff",
   

  },
  fullscreenContainer: {
  width: "100%",
  height: "100%",
  background: "white",
  padding: "16px",
  overflow: "auto",
  },

};

export default Retainersx;